
import { httpPost,httpGet } from './request/index'
// 登录
export function login (data) {
  return httpPost('/wall/data/login', data)
}
// 地图
export function getProducts (data) {
  return httpPost('/wall/dataScreen/getProducts', data)
}
// 今日投递垃圾
export function getGarbageData (data) {
  return httpPost('/wall/dataScreen/getGarbageData', data)
}

// 运营数据
export function getUnqualifiedCount (data) {
  return httpPost('/wall/dataScreen/getUnqualifiedCount', data)
}

// 运营数据
// export function randomCheck (data) {
//   return httpPost('/wall/dataScreen/randomCheck', data)
// }
//点位数量
// export function getDetailedCount(data){
//   return httpPost('/wall/dataScreen/getDetailedCount',data)
// }
//调度信息
export function getAlarmRecordLimit(data){
  return httpPost('/wall/dataScreen/getAlarmRecordLimit',data)
}
//获取所有视频
export function getDeviceVideo (data) {
  return httpPost('/wall/dataScreen/getDeviceVideo', data)
}

//获取设备的状态
export function getProductDevice (data) {
  return httpPost('/wall/dataScreen/getProductDevice', data)
}

//控制设备的状态
export function openOrClose (data) {
  return httpPost('/wall/dataScreen/openOrClose', data)
}

//获取小区
export function getEstateList (data) {
  return httpPost('/wall/dataScreen/getEstateList', data)
}

//获取设备
export function getProductVideos (data) {
  return httpPost('/wall/dataScreen/getProductVideos', data)
}


//获取地图点位
export function getRegionByProduct (data) {
  return httpPost('/smart/wall/cockpit/getRegionByProduct', data)
}

//获取地图点位详情
export function getPointDetails (data) {
  return httpPost('/smart/wall/cockpit/getPointDetails', data)
}

//一周投递总数据
export function get7DayGarbageTotal (data) {
  return httpPost('/smart/wall/cockpit/get7DayGarbageTotal', data)
}

//今日回收投递总数居
export function getToDayGarbageTotal (data) {
  return httpPost('/smart/wall/cockpit/getToDayGarbageTotal', data)
}

//今日回收投递总数居
export function getAlarmRecord (data) {
  return httpPost('/smart/wall/cockpit/getAlarmRecord', data)
}

//运营数据
export function operationalData (data) {
  return httpPost('/smart/wall/cockpit/operationalData', data)
}

//地图点位视频播放
export function doPlay (data) {
  return httpPost('/smart/wall/dispatchCenter/doPlay', data)
}

//天气接口
export function getWeather (data) {
  return httpGet('/smart/wall/cockpit/getWeather', data)
}

// 抽查信息展示
export function randomCheck (data) {
  return httpPost('/smart/wall/cockpit/randomCheck', data)
}

// 运营点位信息统计
export function getDetailedCount (data) {
  return httpPost('/smart/wall/cockpit/getDetailedCount', data)
}

//站点社区
export function getDeviceStatistics (data) {
  return httpPost('/recycle/wall/cockpit/getDeviceStatistics', data)
}



// WEBPACK FOOTER //
// ./src/api/basePath.js